// A small, non-sensitive "you've signed in here before" hint kept in
// localStorage. It lets the login screen greet a returning user by their shop
// name WITHOUT hardcoding anything: the name is only ever what a real prior login
// supplied. A fresh device has no hint, so the login stays generic. It persists
// across logout (that's what "logged in recently" means) and carries no
// credential, just display strings.
const KEY = "klutch-last-login";

export interface SessionHint {
  userName?: string;
  shopName?: string;
}

export function getSessionHint(): SessionHint | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as SessionHint) : null;
  } catch {
    return null;
  }
}

export function rememberSession(hint: SessionHint): void {
  try {
    const prev = getSessionHint() ?? {};
    // Merge so we don't wipe a previously-known shop name when the backend
    // hasn't (yet) sent one this session.
    localStorage.setItem(KEY, JSON.stringify({ ...prev, ...clean(hint) }));
  } catch {
    /* ignore */
  }
}

function clean(h: SessionHint): SessionHint {
  const out: SessionHint = {};
  if (h.userName) out.userName = h.userName;
  if (h.shopName) out.shopName = h.shopName;
  return out;
}
